import React, { useState } from "react";

const GeocodePromptModal = ({
  isOpen,
  onClose,
  onSubmit,
  title = "Fill in GPS Coordinates",
  description = "Provide the city, state, and country so we can resolve this address accurately.",
  initialCity = "",
  initialState = "",
  initialCountry = "",
}) => {
  const [city, setCity] = useState(initialCity);
  const [state, setState] = useState(initialState);
  const [country, setCountry] = useState(initialCountry);
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit({ city, state, country });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-5">
        <h3 className="text-lg font-semibold mb-1">{title}</h3>
        <p className="text-sm text-gray-500 mb-4">{description}</p>
        <div className="space-y-2">
          <input
            type="text"
            placeholder="City"
            className="form-input input input-bordered w-full"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <input
            type="text"
            placeholder="State / Region"
            className="form-input input input-bordered w-full"
            value={state}
            onChange={(e) => setState(e.target.value)}
          />
          <input
            type="text"
            placeholder="Country"
            className="form-input input input-bordered w-full"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            className="btn btn-ghost btn-sm"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            className="btn bg-[#004a7e] hover:bg-[#00385b] text-white btn-sm disabled:opacity-60"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Locating…" : "Fill in GPS"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeocodePromptModal;
